import React, { FC, HTMLAttributes, PropsWithChildren, ReactNode } from 'react'
import styles from './Accordion.module.scss'
import classNames from 'classnames'
import PlusIcon from 'svg/heavier-plus.svg'

type AccordionItemProps = {
  title: string
  headerCustomStyle?: string
  contentCustomStyle?: string
  itemCustomStyle?: string
  activeIndex: ReadonlyArray<string>
  onChangeIndex: (index: string) => void
  CustomIcon?: React.ReactElement<HTMLAttributes<SVGElement>>
}

const AccordionItem: FC<PropsWithChildren<AccordionItemProps>> = ({
  children,
  title,
  activeIndex,
  onChangeIndex,
  headerCustomStyle = '',
  contentCustomStyle = '',
  itemCustomStyle = '',
  CustomIcon,
}) => {
  const isTitleActiveIndex = activeIndex.includes(title)

  return (
    <div className={styles.accordionItemWrapper}>
      <input
        type='checkbox'
        id={`toggle-${title}`}
        className={styles.toggleInput}
        checked={isTitleActiveIndex}
        readOnly
      />
      <label htmlFor={`toggle-${title}`}>
        <div
          className={classNames({
            [itemCustomStyle]: itemCustomStyle !== '',
          })}
        >
          <div
            className={classNames(styles.itemBox, {
              [styles.itemBoxVisible]: isTitleActiveIndex,
              [headerCustomStyle]: headerCustomStyle !== '',
            })}
            onClick={() => onChangeIndex(title)}
          >
            <span className={styles.itemBoxSpan}>{title}</span>
            {CustomIcon &&
              React.cloneElement(
                CustomIcon as React.ReactElement,
                {
                  'data-active': isTitleActiveIndex as any,
                } as any
              )}

            {!CustomIcon && (
              <PlusIcon className={styles.expandCollapseIcon} data-active={isTitleActiveIndex} />
            )}
          </div>
          <div
            className={classNames(styles.contentBox, {
              [styles.contentBoxVisible]: isTitleActiveIndex,
              [contentCustomStyle]: contentCustomStyle !== '' && isTitleActiveIndex,
            })}
          >
            {children}
          </div>
          <hr className={classNames('hrDivider', styles.accordionItemDivider)} />
        </div>
      </label>
    </div>
  )
}

export default AccordionItem
